import $ from 'jquery';

// $(window).scroll(function() {    
//     var scroll = $(window).scrollTop();

//      //>=, not <=
//     if (scroll >= 20) {
//         //clearHeader, not clearheader - caps H
//         $(".sticky-top").addClass("sticky");
//     } else {
//         $(".sticky-top").removeClass("sticky");
//     }
// }); //missing );

// Counter

// inViewport jQuery plugin
// http://stackoverflow.com/a/26831113/383904



$(function($, win) {
    $.fn.inViewport = function(cb) {
      return this.each(function(i,el){
        function visPx(){
          var H = $(this).height(),
              r = el.getBoundingClientRect(), t=r.top, b=r.bottom;
          return cb.call(el, Math.max(0, t>0? H-t : (b<H?b:H)));  
        } visPx();
        $(win).on("resize scroll", visPx);
      });
    };
  }(jQuery, window));
  
  
  jQuery(function($) { // DOM ready and $ in scope
  
    $(".fig-number").inViewport(function(px) { // Make use of the `px` argument!!!
      // if element entered V.port ( px>0 ) and
      // if prop initNumAnim flag is not yet set
      //  = Animate numbers
      if(px>0 && !this.initNumAnim) { 
        this.initNumAnim = true; // Set flag to true to prevent re-running the same animation
        $(this).prop('Counter',0).animate({
          Counter: $(this).text()
        }, {
          duration: 3000,
          step: function (now) {
            $(this).text(Math.ceil(now));
          }
        });         
      }
    });
  
});




$('#video-modal').on('hidden.bs.modal', function(){
  $(this).find('iframe').html("");
  $(this).find('iframe').attr("src", "");
});


jQuery(document).ready(function ($) {

    $('.marquee').each(function () {

        const $marquee = $(this);
        const $track = $marquee.find('.marquee__track');
        const $item = $track.find('.marquee__item').first();

        // Duplicate enough items to always fill the visible area
        while ($track.outerWidth() < $marquee.outerWidth() + ($item.outerWidth(true) * 2)) {
            $track.append($item.clone());
        }

        let position = 0;
        const speed = 1;

        const itemWidth = $item.outerWidth(true);

        function animate() {

            position -= speed;

            // Instead of visibly jumping back to the start,
            // move forward by exactly one repeated item's width.
            if (position <= -itemWidth) {
                position += itemWidth;
            }

            $track.css(
                'transform',
                'translate3d(' + position + 'px, 0, 0)'
            );

            requestAnimationFrame(animate);
        }

        animate();

    });

});